module.exports = __webpack_public_path__ + "img/profile_placeholder.84533488.svg";